import React from "react";
import { Container, Box, Typography, Button } from "@mui/material";
import { CookiesData } from "../assets/data";
import Footer from "../components/Footer";
import useMediaQuery from "@mui/material/useMediaQuery";
import termimg from "../assets/termD.png";
import { Link } from "react-router-dom";

const Complaints = () => {
  const matches = useMediaQuery("(max-width:500px)");

  return (
    <>
      <Container maxWidth="xl">
        <Box className="terms_main">
          <Box className="termsDiv">
            <Typography variant="h5" className="faq_title">
              Complaints <br />
              Procedure
            </Typography>
            <Typography className="complaints_page_style" variant="body1">
              If you are unhappy with our service, we are sorry and we would
              like to put it right.
            </Typography>
            <Typography className="complaints_page_style" variant="body1">
              <strong>How to make a complaint</strong>{" "}
            </Typography>
            <Typography className="complaints_page_style" variant="body1">
              <strong>Call us:</strong> 0330 111 4442
            </Typography>
            <Typography className="complaints_page_style" variant="body1">
              <strong>Email us:</strong> customerservices@wecareboilerrepair.com
            </Typography>
            <Typography className="complaints_page_style" variant="body1">
              <strong>Write to us:</strong> Customer Resolutions, WeCare Boiler
              Repair Ltd, 30 The Loont, Winsford, Cheshire, CW7 1EU
            </Typography>
            <Typography className="complaints_page_style" variant="body1">
              <strong>Resolving Your Complaint</strong>{" "}
            </Typography>
            <Typography className="complaints_page_style" variant="body1">
              {" "}
              At WeCare, we aim to acknowledge, respond to, and resolve your
              complaint within 3 business days of receipt.
            </Typography>
            <Typography className="complaints_page_style" variant="body1">
              <strong>
                Upon receiving your complaint, we will send you a written
                acknowledgement that includes:
              </strong>{" "}
            </Typography>

            <ul>
              <li>
                A timeline for further correspondence, if necessary, which we
                aim to complete within 4 weeks, but no more than 8 weeks from
                receiving your complaint.
              </li>

              <li>
                The name and contact details of the person handling your
                complaint.
              </li>

              <li>A Copy of Our Customer Complaints Procedure.</li>

              <li>
                If we resolve your complaint within 3 business days, we will
                provide a summary resolution communication that includes details
                about the ombudsman.
              </li>

              <li>
                {" "}
                In the rare case that our investigation takes longer than 8
                weeks, we will inform you in writing, explaining the delay and
                providing an estimated date for further contact
              </li>
            </ul>

            <Typography className="complaints_page_style" variant="body1">
              <strong>
                Once our investigation is complete, we will send you a written
                response, which will be either:
              </strong>{" "}
            </Typography>

            <ul>
              <li>
                <strong>An Offer Letter:</strong> If we determine you are
                entitled to some redress and believe we have fully addressed
                your complaint, we will include the agreed redress in our final
                response letter.
              </li>

              <li>
                <strong>A Final Response:</strong> If we believe we have fully
                addressed your complaint without the need for redress.
              </li>
            </ul>

            <Typography className="complaints_page_style" variant="body1">
              <strong>We Consider a Complaint Closed When:</strong>{" "}
            </Typography>

            <ul>
              <li>We have sent you a final response.</li>

              <li>
                You have indicated in writing that you accept our offer or
                response.
              </li>
              <li>
                You fail to respond to our correspondence within 8 weeks of our
                written response.
              </li>
            </ul>

            <Typography className="complaints_page_style" variant="body1">
              <strong>The Financial Ombudsman Service</strong>{" "}
            </Typography>

            <div>
              <p>
                You have the right to refer your complaint to the Financial
                Ombudsman Service (FOS) at any time. If we have not resolved
                your complaint within 8 weeks, or if you are dissatisfied with
                our final response, you may seek their assistance. The FOS will
                require our consent to investigate if we have not had the chance
                to address your complaint or if we have not sent you a final
                response within 8 weeks.
              </p>
              <p>
                To refer your complaint to the Financial Ombudsman Service, you
                must do so within 6 months of the date of our final response.
                After this period, the Ombudsman may refuse to consider your
                case.
              </p>
              <p>
                While handling your complaint, we will inform you if you have
                the option to refer it to the Financial Ombudsman Service. If
                applicable, we will provide you with details on how to use their
                services.
              </p>
              <p>
                The Financial Ombudsman Service offers an independent,
                impartial, and free service. If you are dissatisfied with our
                final response or at any point after submitting your complaint,
                you can refer the matter to the Financial Ombudsman Service.
              </p>
            </div>
          </Box>
        </Box>
      </Container>
      <Footer />
    </>
  );
};

export default Complaints;
